<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card class="pb-2">
      <v-card-title class="text-h5 grey lighten-2"> 修改帳號資訊 </v-card-title>
      <v-card-text class="mt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="text-h6 font-weight-bold">基本資訊</div>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="* 帳號"
                :value="user.帳號"
                outlined
                dense
                hide-details
                disabled
                :rules="[(v) => !!v || '此為必填欄位']"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="isOverTime ? '* 密碼' : '密碼'"
                v-model="password"
                type="password"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                label="* 醫事單位"
                v-model="user.醫事單位"
                outlined
                dense
                hide-details
                :rules="[(v) => !!v || '此為必填欄位']"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="* 醫事機構代碼"
                v-model="user.醫事機構代碼"
                outlined
                dense
                hide-details
                :rules="[(v) => !!v || '此為必填欄位']"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="* 姓名"
                v-model="user.姓名"
                outlined
                dense
                hide-details
                :rules="[(v) => !!v || '此為必填欄位']"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="* 聯絡電話"
                v-model="user.聯絡電話"
                outlined
                dense
                hide-details
                :rules="[(v) => !!v || '此為必填欄位']"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="* Email"
                v-model="user.email"
                outlined
                dense
                hide-details
                :rules="[(v) => !!v || '此為必填欄位']"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="logout" v-if="isOverTime"> 登出 </v-btn>
        <v-btn text @click="dialog = false" v-else> 關閉 </v-btn>
        <v-btn color="primary" @click="update"> 儲存修改 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import util from "@/mixins/util";
export default {
  name: "MyAccount",
  props: ["value"],
  mixins: [util],
  data: () => ({
    password: "",
    valid: false,
    user: {},
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    this.user = _.cloneDeep(this.$store.state.user);
  },
  methods: {
    logout() {
      this.$emit("logout");
    },
    isStrongPassword(pwd) {
      if (!pwd || pwd.length < 8) return false;
      const hasLower = /[a-z]/.test(pwd);
      const hasUpper = /[A-Z]/.test(pwd);
      const hasDigit = /[0-9]/.test(pwd);
      const hasSpecial = /[!@#$%^&*()_+\-=\[\]{}~;':"\\|,.<>\/?]/.test(pwd);
      const categories = [hasLower, hasUpper, hasDigit, hasSpecial].filter(
        Boolean
      ).length;
      return categories >= 3;
    },
    async update() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        if (this.isOverTime || this.password) {
          if (!this.isStrongPassword(this.password)) {
            this.$toast.error(
              "密碼長度應為8碼(含8碼)以上，包含英文大寫小寫、特殊符號或數字三種以上"
            );
            this.password = "";
            return;
          }
          this.user.密碼 = this.password;
        } else {
          delete this.user.密碼;
        }

        try {
          let data = (await this.axios.post("/dashboard/user", this.user)).data;
          this.$store.commit("setState", {
            user: data,
          });
          this.user.password = "";
          this.dialog = false;
          this.$toast.success("修改成功");
          this.$emit("load");
        } catch (e) {
          this.$toast.error(e.response.data || "修改失敗，請聯繫系統管理者！");
        }
      }
    },
  },
};
</script>

<style></style>
